import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import React__default from 'react';
import clsx from 'clsx';
import ExpandingTextarea from 'react-expanding-textarea';
import inputStyles from '../Input/Input.module.css.js';
import styles from './Textarea.module.css.js';

const Textarea = React__default.forwardRef((props, ref) => {
    const { isError = false, isRequired = false, disabled, ...restProps } = props;
    const className = clsx(inputStyles.input, styles.textarea, {
        [inputStyles.disabled]: disabled,
        [inputStyles.isError]: isError,
    });
    return (jsxRuntimeExports.jsx(ExpandingTextarea, { className: className, ref: ref, "aria-required": isRequired, disabled: disabled, "aria-invalid": Boolean(isError), ...restProps }));
});
Textarea.displayName = 'Textarea';

export { Textarea };
//# sourceMappingURL=Textarea.js.map
